import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import UFOSegment from "@atlaskit/react-ufo/segment";

import AccountCreation from "@/components/signup/account-creation";
import { CobrandedProductLogo } from "@/components/signup/bxp-ui-signup/src/components/site-name-form/components/variants/new-user-confluence-workspace-name";
import { SignupBackgroundLayout } from "@/components/signup/layouts";
import { wacToken } from "@/libraries/design/foundations";

import { InputSubmitButton } from "../../../../jira/free/components/submit-input";
import { Jfind1315SubHeading } from "../../components/jfind-1315-subheading";
import { UnderlineWord } from "../cobranded-logged-out-form";

export const Cfind1192SignupForm = () => {
    return (
        <div data-testid="cfind-1192-signup-form">
            <UFOSegment name="cfind-1192-account-creation-form">
                <SignupBackgroundLayout
                    ProductLogo={<CobrandedProductLogo />}
                    page="CFIND_1192_SIGNUP_FORM"
                >
                    <h1 css={h1Css}>
                        <FormattedMessage
                            id="BxpUiSignup.SignupForm.cfind2049.header"
                            defaultMessage="Get <underline-word>started</underline-word> with Confluence"
                            values={{
                                "underline-word": UnderlineWord
                            }}
                        />
                    </h1>
                    <Jfind1315SubHeading />
                    <AccountCreation
                        Input={<InputSubmitButton />}
                        Submit={null}
                    />
                </SignupBackgroundLayout>
            </UFOSegment>
        </div>
    );
};

const h1Css = css({
    color: wacToken("color.primary.black"),
    fontFamily: wacToken("font.charlie.display"),
    fontSize: "32px",
    fontWeight: 700,
    margin: 0,
    textAlign: "center"
});
